var map = {
	"./activities.svg": "603b",
	"./articles.svg": "36cc",
	"./banners.svg": "0762",
	"./comments.svg": "a403",
	"./dashboard.svg": "f782",
	"./distributors.svg": "4111",
	"./estates.svg": "41e9",
	"./gender-man.svg": "4a7d",
	"./gender-women.svg": "021e",
	"./mall.svg": "155f",
	"./members.svg": "b413",
	"./missions.svg": "84e7",
	"./moments.svg": "b5a6",
	"./money.svg": "3046",
	"./orders.svg": "ee96",
	"./others.svg": "3756",
	"./password.svg": "2a3d",
	"./peoples.svg": "2f11",
	"./permission.svg": "3979",
	"./regions.svg": "6eb5",
	"./setting.svg": "05ff",
	"./shop.svg": "5def",
	"./shopping.svg": "12a5",
	"./username.svg": "c590"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";